// @ts-nocheck
import * as Types from '@src/types/graphql-types';

import { gql } from '@apollo/client';
import * as React from 'react';
import * as Apollo from '@apollo/client';
import * as ApolloReactComponents from '@apollo/client/react/components';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions = {} as const;
export type SpecificationSheetUrlQueryVariables = Types.Exact<{
  input: Types.SpecSheetInput;
}>;


export type SpecificationSheetUrlQuery = { __typename?: 'Query', getSpecificationSheet?: { __typename?: 'SpecificationSheet', url?: string | null, text?: string | null, documentType?: string | null, materialId?: string | null } | null };


export const SpecificationSheetUrlDocument = gql`
    query SpecificationSheetUrl($input: SpecSheetInput!) {
  getSpecificationSheet(input: $input) {
    url
    text
    documentType
    materialId
  }
}
    `;
export type SpecificationSheetUrlComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SpecificationSheetUrlQuery, SpecificationSheetUrlQueryVariables>, 'query'> & ({ variables: SpecificationSheetUrlQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SpecificationSheetUrlComponent = (props: SpecificationSheetUrlComponentProps) => (
      <ApolloReactComponents.Query<SpecificationSheetUrlQuery, SpecificationSheetUrlQueryVariables> query={SpecificationSheetUrlDocument} {...props} />
    );
    

/**
 * __useSpecificationSheetUrlQuery__
 *
 * To run a query within a React component, call `useSpecificationSheetUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpecificationSheetUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpecificationSheetUrlQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSpecificationSheetUrlQuery(baseOptions: Apollo.QueryHookOptions<SpecificationSheetUrlQuery, SpecificationSheetUrlQueryVariables> & ({ variables: SpecificationSheetUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SpecificationSheetUrlQuery, SpecificationSheetUrlQueryVariables>(SpecificationSheetUrlDocument, options);
      }
export function useSpecificationSheetUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SpecificationSheetUrlQuery, SpecificationSheetUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SpecificationSheetUrlQuery, SpecificationSheetUrlQueryVariables>(SpecificationSheetUrlDocument, options);
        }
export function useSpecificationSheetUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SpecificationSheetUrlQuery, SpecificationSheetUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SpecificationSheetUrlQuery, SpecificationSheetUrlQueryVariables>(SpecificationSheetUrlDocument, options);
        }
export type SpecificationSheetUrlQueryHookResult = ReturnType<typeof useSpecificationSheetUrlQuery>;
export type SpecificationSheetUrlLazyQueryHookResult = ReturnType<typeof useSpecificationSheetUrlLazyQuery>;
export type SpecificationSheetUrlSuspenseQueryHookResult = ReturnType<typeof useSpecificationSheetUrlSuspenseQuery>;
export type SpecificationSheetUrlQueryResult = Apollo.QueryResult<SpecificationSheetUrlQuery, SpecificationSheetUrlQueryVariables>;